class AutocompletionForm {
	constructor(el){
		let self = this;

		this.form = el;
		this.current = 0;
		this.list = [];
		this.autocomplete = null;

		$(this.form).on('click', 'ul li', function(e){
			self.autocomplete.applyCompletion($(this).text());
		});
	}

	setAutocompleter(obj){
		this.autocomplete = obj;
	}

	show(list){
		this.current = 0;
		this.list = list;

		let $form = $(this.form);
		$form.html('');

		let $ul = $('<ul/>');
		for (let word of list){
			let $li = $('<li/>');
			$li.text(word);
			$ul.append($li);
		}
		$form.append($ul);
		$form.show();
		this.updateStylesAndScroll();
	}

	hide(){
		$(this.form).hide();
	}

	selectNext(){
		++this.current;
		if (this.current >= this.list.length){
			this.current = 0;
		}

		this.updateStylesAndScroll();
	}

	selectPrevious(){
		--this.current;
		if (this.current < 0){
			this.current = this.list.length - 1;
		}

		this.updateStylesAndScroll();
	}

	getSelected(){
		return this.list[this.current];
	}

	updateStylesAndScroll(){
		let $form = $(this.form);
		let $lis = $form.find('ul li');
		$lis.removeClass('selected');
		$($lis[this.current]).addClass('selected');

		let form = this.form;
		let li = $lis[this.current];
		if (li.offsetTop < form.scrollTop){
			form.scrollTop = li.offsetTop;
		} else if (li.offsetTop + li.offsetHeight > form.scrollTop + form.clientHeight){
			form.scrollTop = li.offsetTop + li.offsetHeight - form.clientHeight;
		}
	}
}

module.exports = AutocompletionForm;
